import React from 'react';
import Products from '../../utils/tabs/products/Products';

/**
 * Affiche le composant d'information sur les produits du colis dans le drawer
 * de la section Expéditions
 */
const ProductsTab = () => (
  <div>
    <Products />
  </div>
);

export default ProductsTab;
